import GATSBY_COMPILED_MDX from "/opt/build/repo/content/static-pages/what-is-ebpf/index.fr-fr.md";
import {graphql} from 'gatsby';
import React from 'react';
import TableOfContents from 'components/pages/static/table-of-contents';
import Content from 'components/shared/content';
import Layout from 'components/shared/layout/layout';
import SEO from 'components/shared/seo';
import createPageUrl from 'utils/create-page-url';
const pages = ['what-is-ebpf'];
const pageUrls = pages.reduce((acc, page) => {
  acc[page] = createPageUrl(page);
  return acc;
}, {});
const StaticPage = ({data: {mdx: {tableOfContents, frontmatter: {title}}}, children, location}) => {
  let pageUrl = false;
  Object.keys(pageUrls).forEach(page => {
    if (location.pathname.includes(page)) {
      pageUrl = page;
    }
  });
  return React.createElement(Layout, {
    pageUrls: pageUrl ? pageUrls[pageUrl] : null
  }, React.createElement("div", {
    className: "safe-paddings"
  }, React.createElement("div", {
    className: "container grid grid-cols-12 mt-20 grid-gap-x mb-28 lg:mb-24 lg:mt-16 md:mb-20 md:mt-12"
  }, React.createElement(TableOfContents, {
    className: "col-span-3 lg:col-span-4 lg:max-w-[300px] md:hidden",
    items: tableOfContents.items
  }), React.createElement("article", {
    className: "col-start-5 col-end-13 md:col-span-full"
  }, React.createElement("h1", {
    className: "font-semibold heading-10xl leading-dense"
  }, title), React.createElement(TableOfContents, {
    className: "hidden mt-10 md:block",
    title: "Table of contents",
    items: tableOfContents.items
  }), React.createElement(Content, {
    className: "mt-10 prose-static",
    title: title,
    items: tableOfContents.items,
    content: children
  })))));
};
StaticPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(StaticPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query StaticPageQuery($id: String!) {
    mdx(id: { eq: $id }) {
      frontmatter {
        title
        ogTitle
        ogDescription
        ogKeywords
      }
      tableOfContents(maxDepth: 3)
    }

    locales: allLocale(filter: { ns: { in: ["shared"] } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
export const Head = ({location: {pathname}, data: {mdx: {frontmatter: {title, ogTitle, ogDescription, ogKeywords}}}}) => React.createElement(SEO, {
  pathname: pathname,
  title: ogTitle || title,
  description: ogDescription,
  keywords: ogKeywords
});
